// sonido.js
// Sonidos cortos de feedback, sintetizados con Web Audio API (sin archivos de
// audio externos, cero peso agregado). Best-effort: si el navegador bloquea
// el audio o no soporta AudioContext, no debe romper ningún flujo — se
// ignora en silencio.

let audioCtx = null;
const obtenerContexto = () => {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  if (!audioCtx) audioCtx = new AudioCtx();
  if (audioCtx.state === 'suspended') audioCtx.resume();
  return audioCtx;
};

// Parciales NO armónicos (como un disco de metal real, no una nota musical
// limpia) para el timbre de cada clink de moneda.
const PARCIALES_MONEDA = [
  { mult: 1,   vol: 0.30 },
  { mult: 1.8, vol: 0.18 },
  { mult: 2.6, vol: 0.10 },
];

// Un clink de moneda: los parciales metálicos agudos + un click de ruido
// filtrado en banda que da el golpe seco contra la superficie.
function moneda(ctx, cuando, fundamental, volumenBase, decay) {
  PARCIALES_MONEDA.forEach(({ mult, vol }) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = fundamental * mult;
    gain.gain.setValueAtTime(vol * volumenBase, cuando);
    gain.gain.exponentialRampToValueAtTime(0.0001, cuando + decay);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(cuando);
    osc.stop(cuando + decay + 0.03);
  });

  const duracionRuido = 0.012;
  const buffer = ctx.createBuffer(1, ctx.sampleRate * duracionRuido, ctx.sampleRate);
  const datos = buffer.getChannelData(0);
  for (let i = 0; i < datos.length; i++) {
    datos[i] = (Math.random() * 2 - 1) * (1 - i / datos.length);
  }
  const ruido = ctx.createBufferSource();
  ruido.buffer = buffer;
  const filtro = ctx.createBiquadFilter();
  filtro.type = 'bandpass';
  filtro.frequency.value = 7500;
  filtro.Q.value = 1.2;
  const gainRuido = ctx.createGain();
  gainRuido.gain.setValueAtTime(0.20 * volumenBase, cuando);
  gainRuido.gain.exponentialRampToValueAtTime(0.0001, cuando + duracionRuido);
  ruido.connect(filtro);
  filtro.connect(gainRuido);
  gainRuido.connect(ctx.destination);
  ruido.start(cuando);
}

// "Puñado de monedas": varios clinks cayendo en cadena, con volumen y
// pitch decrecientes.
export function reproducirSonidoExito() {
  try {
    const ctx = obtenerContexto();
    if (!ctx) return;
    const t = ctx.currentTime;
    moneda(ctx, t,        3600, 1.0,  0.11);
    moneda(ctx, t + 0.07, 4100, 0.75, 0.10);
    moneda(ctx, t + 0.15, 3300, 0.55, 0.12);
    moneda(ctx, t + 0.24, 3900, 0.35, 0.09);
  } catch {
    // Silencioso a propósito: un sonido de feedback nunca debe frenar el guardado.
  }
}
